import React from 'react';
import { Container } from './styles';

const Footer: React.FC = () => {
  return (
    <Container>
      <p>
        Developed by <a href="https://rafashiga.github.io">Rafael Shiga</a>
      </p>
    </Container>
  );
};

export default Footer;
